import { render } from "./WebSiteBehavior.vue?vue&type=template&id=ca6e268c"
import script from "./WebSiteBehavior.vue?vue&type=script&lang=js"
export * from "./WebSiteBehavior.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__